// update both when you make changes.

const roles = {
  DEFAULT_MOTHER_BUSINESS_ROLE: 'default_mother_business_role',
  DEFAULT_BUSINESS_ROLE: 'default_business_role',
  DEFAULT_DOCTOR_ROLE: 'default_doctor_role',
  DEFAULT_CUSTOMER_ROLE: 'default_customer_role',
  DEFAULT_ADMIN_TOOL_USER_ROLE: 'default_admin_tool_user_role',
  DEFAULT_EXTERNAL_ADMIN_ROLE: 'default_external_admin_role',
  ADMINISTRATOR_ROLE: 'administrator',
  ANALYTICS_DEPARTMENT_USER_ROLE: 'analytics_department_user',
  // COMMERCIAL_DEPARTMENT_USER_ROLE: 'commercial_department_user',
  // DEFAULT_ADMIN_TOOL: 'default_admin_tool_user_role',
  // MANAGEMENT_ROLE: 'management',
  QUALITY_DEPARTMENT_USER_ROLE: 'quality_department_user',
  QUALITY_DEPARTMENT_USER_ROLE_2: 'quality_department_user_2',
  
  NUTRITION_GENETICS_USER: 'nutrition_genetics_user', 
  // SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE: 'scientific_department_user_dietician',
  // SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE: 'scientific_department_user_doctor',
  // SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE: 'scientific_department_user_molecular_biologist',
  // SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE: 'scientific_department_user_nutritionist',
  // SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE: 'scientific_department_user_pharmacist',
  THIRD_PARTY_CARDIOLOGIST: 'third_party_cardiologist',
  LOGISTICS_DEPT_USER: 'default_logistics_role',
  SALES: 'default_sales_role',
  MARKETING: 'default_marketing_role',
  DIETICIAN: 'default_dietician_role',
  LAB: 'lab_scientist',
  AL_MANAGER: 'al_manager_role',
};

const realRoleNames = {
  DEFAULT_DOCTOR_ROLE: {value: 'default_doctor_role',name: 'Default doctor role', hidden: true},
  DEFAULT_CUSTOMER_ROLE: {value: 'default_customer_role', name: 'Default customer role', hidden: true},
  DEFAULT_ADMIN_TOOL_USER_ROLE: {value: 'default_admin_tool_user_role', name: 'Default admin tool user role', },
  DEFAULT_EXTERNAL_ADMIN_ROLE: {value: 'default_external_admin_role', name: 'Default external admin role', hidden: true},
  ADMINISTRATOR_ROLE: {value: 'administrator', name: 'Administrator'},
  ANALYTICS_DEPARTMENT_USER_ROLE: {value: 'analytics_department_user', name: 'Analytics department user'},
  // COMMERCIAL_DEPARTMENT_USER_ROLE: 'commercial_department_user',
  // DEFAULT_ADMIN_TOOL: 'default_admin_tool_user_role',
  // MANAGEMENT_ROLE: 'management',
  QUALITY_DEPARTMENT_USER_ROLE: {value: 'quality_department_user', name: 'Scientific Department user 1'},
  QUALITY_DEPARTMENT_USER_ROLE_2: {value: 'quality_department_user_2', name: 'Scientific Department user 2'},
  NUTRITION_GENETICS_USER: {value: 'nutrition_genetics_user', name: 'Nutrition – Genetics User'},
  // SCIENTIFIC_DEPARTMENT_USER_DIETICIAN_ROLE: 'scientific_department_user_dietician',
  // SCIENTIFIC_DEPARTMENT_USER_DOCTOR_ROLE: 'scientific_department_user_doctor',
  // SCIENTIFIC_DEPARTMENT_USER_MOLECULAR_BIOLOGIST_ROLE: 'scientific_department_user_molecular_biologist',
  // SCIENTIFIC_DEPARTMENT_USER_NUTRITIONIST_ROLE: 'scientific_department_user_nutritionist',
  // SCIENTIFIC_DEPARTMENT_USER_PHARMACIST_ROLE: 'scientific_department_user_pharmacist',
  THIRD_PARTY_CARDIOLOGIST: {value: 'third_party_cardiologist', name: 'Chief Scientific Officer'},
  LOGISTICS_DEPT_USER: {value: 'default_logistics_role', name: 'Logistics department user'},
  SALES: {value: 'default_sales_role', name: 'Sales'},
  MARKETING: {value: 'default_marketing_role', name: 'Marketing'},
  DIETICIAN: {value: 'default_dietician_role', name: 'Dietician'},
  LAB: {value:'lab_scientist', name:'Lab Scientist'},
  AL_MANAGER: {value:'al_manager_role', name:'AL Manager'},
};

module.exports = { roles, realRoleNames };
